import { render, staticRenderFns } from "./HistoryMore.vue?vue&type=template&id=350ef280&scoped=true&"
import script from "./HistoryMore.vue?vue&type=script&lang=js&"
export * from "./HistoryMore.vue?vue&type=script&lang=js&"
import style0 from "./HistoryMore.vue?vue&type=style&index=0&id=350ef280&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "350ef280",
  null
  
)

export default component.exports